(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["awakearl-home"] && !Shopify.designMode) return;
  try {
    
  function mountAwakearlCarousel(root) {
    for (const carousel of root.querySelectorAll('[data-ah-carousel]')) {
      if (carousel.dataset.ahReady) continue;
      const track = carousel.querySelector('[data-ah-track]');
      const controls = carousel.querySelector('[data-ah-controls]');
      const count = carousel.querySelector('[data-ah-count]');
      const total = track.children.length;
      const current = () => Math.min(total - 1, Math.round(track.scrollLeft / (track.clientWidth || 1)));
      const move = (direction) => {
        const next = (current() + direction + total) % total;
        track.scrollTo({
          left: next * track.clientWidth,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      };
      carousel.querySelector('[data-ah-previous]').addEventListener('click', () => move(-1));
      carousel.querySelector('[data-ah-next]').addEventListener('click', () => move(1));
      track.addEventListener('scroll', () => {
        count.textContent = (current() + 1) + ' / ' + total;
      }, { passive: true });
      carousel.dataset.ahReady = 'true';
      controls.hidden = false;
    }
  }
  mountAwakearlCarousel(document);
  document.addEventListener('shopify:section:load', (event) => mountAwakearlCarousel(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
